/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ChevronUpIcon = /*#__PURE__*/ createSvgIcon(
  'ChevronUpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 9.062L6.583 12.48a.729.729 0 01-1.062 0 .729.729 0 010-1.062l3.958-3.959A.718.718 0 0110 7.23c.194 0 .368.077.52.23l3.96 3.958c.152.152.228.326.228.52a.718.718 0 01-.229.521.729.729 0 01-1.062 0L10 9.062z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ChevronUpIcon;
